'use client';

import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import type { Simplify } from '../../../../prismicio-types';
import { Container } from '@/components';

import styles from './ourValuesInner.module.scss';
import { OurValuesIcon } from './assets/OurValuesIcon';
import { useVisible } from '@/hooks';

interface OurValuesInnerProps {
  data: Simplify<Content.OurValuesSliceDefaultPrimary>;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
  heading4: ({ children }) => <h4 className={styles.heading}>{children}</h4>,
};

export const OurValuesInner = ({ data }: OurValuesInnerProps) => {
  const [isVisible, id] = useVisible();

  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <Container id={id}>
      <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
        <PrismicRichText field={data.title} components={components} />
      </div>
      <ul className={styles.list}>
        {data.cards.map((card, index) => (
          <li
            className={`${styles.card} ${isVisibleStyles}`}
            key={card.description || index}
            style={{ transitionDelay: `${index * 0.13}s` }}
          >
            <div className={styles.heading_wrapper}>
              <div className={styles.icon}>
                <OurValuesIcon icon={card.icon} />
              </div>
              <PrismicRichText field={card.heading} components={components} />
            </div>
            <p className={styles.description}>{card.description}</p>
          </li>
        ))}
      </ul>
    </Container>
  );
};
